export function dataInRequest(params = {}) {
  return {
    type: '@afericaoDvec/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@afericaoDvec/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@afericaoDvec/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@afericaoDvec/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@afericaoDvec/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@afericaoDvec/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@afericaoDvec/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@afericaoDvec/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@afericaoDvec/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@afericaoDvec/RECORD_FILTERING',
    payload: { params },
  };
}
